import { Component } from '@angular/core';
import { PurchaseOrderLine, PurchaseOrderLineItem } from 'app/core/model/entity-model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { AppInformationService } from 'app/core/core.module';

@Component({
    selector: 'app-po-misc-line-dialog',
    template: `
        <div class="modal-header">
            <h4 class="modal-title">Miscellaneous Line</h4>
        </div>
        <div class="modal-body" (keyup.esc)="close()">
            <dx-form [formData]="purchaseOrderLine" validationGroup="poMiscValidationGroup">
                <dxi-item dataField="partNumber" [label]="{ text: 'Part #' }"></dxi-item>
                <dxi-item dataField="mfgPartNumber" [label]="{ text: 'Mfg Part #' }"></dxi-item>
                <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: 100 }">
                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="quantity" editorType="dxNumberBox" [editorOptions]="{ step: 0, width: '150px' }">
                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="cost" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 5 }, width: '150px' }">
                    <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxi-item>
                <dxi-item
                    dataField="purchaseOrderLineItemId"
                    [label]="{ text: 'Line Item' }"
                    editorType="dxSelectBox"
                    [editorOptions]="{ dataSource: purchaseOrderLineItems, valueExpr: 'id', displayExpr: 'name', showClearButton: true, width: '200px' }"
                ></dxi-item>
                <dxi-item dataField="note"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" (click)="save()">Save</button>
            <button class="btn btn-light" (click)="close()">Cancel</button>
        </div>
    `,
    styles: [],
    standalone: false,
})
export class PoMiscLineDialogComponent {
    result: Subject<any> = new Subject<any>();
    purchaseOrderLine: PurchaseOrderLine;
    purchaseOrderLineItems: PurchaseOrderLineItem[];
    validationGroup = 'poMiscValidationGroup';
    errorAction = 'saving';
    mode: string;

    constructor(
        public modalRef: BsModalRef,
        private appInfo: AppInformationService,
    ) {}

    save() {
        const result = this.validate();
        if (!result) return;

        this.result.next({ success: true, purchaseOrderLine: this.purchaseOrderLine });
    }

    close() {
        if (this.mode === 'add') this.purchaseOrderLine.entityAspect.setDeleted();
        else this.purchaseOrderLine.entityAspect.rejectChanges();

        this.result.next(false);
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
